import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  MenuItem,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import CustomTextInput from 'components/Forms/CustomTextInput';
import useCreateInventory from 'components/MenuNew/hooks/useCreateInventory';
import SearchableInventorySelect from 'components/MenuNew/FormView/Inventory/SearchableInventorySelect';

const CreateInventoryDialog = ({
  open,
  onClose,
  onSave = () => {},
  title = editingItem ? 'Edit Inventory' : 'Add Inventory item to the product',
  productId,
  replaceInventory,
  productInventory,
  editingItem,
  productFormMethods,
  currentData,
}) => {
  const { t } = useTranslation();

  const {
    inventoryCreateMethod,
    handleAddInventory,
    loading,
    filteredBusinessInventoryList,
    handleReplaceInventory,
    selectedInventoryItem,
    handleChangeInventory,
  } = useCreateInventory(
    open,
    productId,
    onClose,
    replaceInventory,
    productInventory,
    editingItem,
    productFormMethods
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        {editingItem ? t('Edit Inventory') : t(title)}
      </DialogTitle>

      <FormProvider {...inventoryCreateMethod}>
        <form
          onSubmit={inventoryCreateMethod.handleSubmit(
            editingItem ? handleReplaceInventory : handleAddInventory
          )}
        >
          <DialogContent>
            <Box
              sx={{ pt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {t('Select the inventory item to add to the product')}
              </Typography>
              <SearchableInventorySelect
                value={selectedInventoryItem}
                onChange={handleChangeInventory}
                currentData={currentData}
                placeholder={`${t('Search from')} ${
                  filteredBusinessInventoryList?.length
                } ${t('inventory items...')}`}
                isDisabled={false}
                filteredBusinessInventoryList={filteredBusinessInventoryList}
              />
              <CustomTextInput
                name="qty"
                label={t('Qty')}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5,
                  },
                  zIndex: 0,
                  minHeight: '64px',
                }}
              />
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button
              onClick={onClose}
              color="secondary"
              variant="outlined"
              sx={{ borderRadius: 1.5 }}
            >
              {t('Cancel')}
            </Button>
            <LoadingButton
              type="submit"
              loading={loading}
              color="primary"
              variant="contained"
              disabled={
                !inventoryCreateMethod?.formState?.isDirty ||
                !selectedInventoryItem ||
                Object.keys(inventoryCreateMethod?.formState?.errors)?.length >
                  0
              }
              sx={{ borderRadius: 1.5, ml: 1 }}
            >
              {editingItem ? t('Save') : t('Add')}
            </LoadingButton>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default CreateInventoryDialog;
